<template>
    <v-row class="mt-1">
        <v-col cols="12">
            <h1 class="text-brand">Reporting</h1>
            <p class="lead">View task results and usage.</p>
        </v-col>
        <v-col cols="6">
            <v-card class="d-flex flex-column justify-space-between">
                <h2>Overview</h2>
                <p>View reading test question results over time at class, group or pupil level.</p>
                <v-btn
                    variant="flat"
                    color="secondary-container"
                    class="align-self-start mt-4 order-3"
                    to="/teacher/reporting-overview"
                    >View overview</v-btn
                >
            </v-card>
        </v-col>
        <v-col>
            <v-card class="d-flex flex-column justify-space-between">
                <h2>Combined results</h2>
                <p>View pupil reading test question results combined and over time.</p>
                <v-btn
                    variant="flat"
                    color="secondary-container"
                    class="mt-4 align-self-start order-3"
                    to="/teacher/reporting-combined-results"
                    >View combined results</v-btn
                >
            </v-card>
        </v-col>
        <v-col>
            <v-card class="d-flex flex-column justify-space-between">
                <h2>Question set results</h2>
                <p>View pupil results for a specific question set.</p>
                <v-btn
                    variant="flat"
                    color="secondary-container"
                    class="mt-4 align-self-start order-3"
                    to="/teacher/reporting-question-set"
                    >View question set results</v-btn
                >
            </v-card>
        </v-col>
        <v-col>
            <v-card class="d-flex flex-column justify-space-between">
                <h2>Usage</h2>
                <p>View overall usage for your pupils.</p>
                <v-btn
                    variant="flat"
                    color="secondary-container"
                    class="mt-4 align-self-start order-3"
                    to="/teacher/reporting-usage"
                    >View usage</v-btn
                >
            </v-card>
        </v-col>
    </v-row>
</template>
<script setup lang="ts">
definePage({ meta: { area: 'reporting' } });
</script>
<style scoped lang="scss">
h2 {
    margin-top: 0;
}
</style>
